import { Button, Spinner, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { useGetOrganizationQuery } from "../../autogen/bff-api";

export type OrganizationQuery = ReturnType<typeof useGetOrganizationQuery>;

const LoadError = ({ query }: { query: OrganizationQuery }) => {
  const { t } = useTranslation();
  return (
    <Text as="span" fontSize="sm" color="smError" role="alert">
      {t("Could not load the company.")}{" "}
      <Button
        variant="link"
        size="sm"
        colorScheme="teal"
        onClick={() => void query.refetch()}
        isLoading={query.isFetching}
      >
        {t("Try again")}
      </Button>
    </Text>
  );
};

export const OrganizationNameCell = ({
  query,
  struckThrough = false,
}: {
  query: OrganizationQuery;
  struckThrough?: boolean;
}) => {
  if (query.isLoading) return <Spinner size="xs" color="smPrimary" />;
  if (query.isError && !query.data) return <LoadError query={query} />;
  return (
    <>
      <Text
        fontSize="sm"
        textDecoration={struckThrough ? "line-through" : undefined}
      >
        {query.data?.name ?? "–"}
      </Text>
      <Text fontSize="xs" color="smMuted">
        {query.data?.organizationNumber ?? "–"}
      </Text>
    </>
  );
};

export const OrganizationNameInline = ({
  query,
}: {
  query: OrganizationQuery;
}) => {
  if (query.isLoading) return <Spinner size="xs" color="smPrimary" />;
  if (query.isError && !query.data) return <LoadError query={query} />;
  return <>{query.data?.name ?? "–"}</>;
};
